<template>
  <ProductComponent />
</template>

<script>
// @ is an alias to /src
import ProductComponent from "@/components/Product/Product.vue";
import { mapState } from "vuex";

export default {
  props: ["id"],
  name: "Basket",
  components: {
    ProductComponent
  },
  computed: {
    ...mapState({
      product: state => state.product.product
    })
  },
  async mounted() {
    await this.$store.dispatch("product/LOAD_PRODUCT", this.id);
   await this.$store.dispatch("product/LOAD_PRODUCT_REVIEWS", this.id);

    await this.$store.dispatch("product/CHECK_FOR_FAVOURITE", this.id);
    await this.$store.dispatch("product/LOAD_RELATED_PRODUCTS");
    this.evtProductDetail(this.product);
  }
};
</script>
